export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS";
export const CONNECT = "CONNECT"
export const DISCONNECT = "DISCONNECT";
